import { render, staticRenderFns } from "./CustomServer.vue?vue&type=template&id=d651e08c&"
import script from "./CustomServer.vue?vue&type=script&lang=js&"
export * from "./CustomServer.vue?vue&type=script&lang=js&"
import style0 from "./CustomServer.vue?vue&type=style&index=0&id=d651e08c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports